<template>
    <div class="col-sm-12 nopads">
        <b-form v-if="!deactivating">
            <h4 class="m-3">
                {{ isEditing()?$t('campaign.edit'):$t('campaign.add') }}
            </h4>
            <div class="col-sm-12">
                <div class="content-header-container"
                     v-bind:style="{ backgroundImage: 'url(' + getBackground() + ')' }">
                    <transition name="fade">
                        <div v-if="!campaignBackground && !photo" class="header-img-overlay">
                        </div>
                    </transition>
                </div>

                <!--Name-->
                <b-form-group
                        class="title"
                        label-for="name">
                  <span class="span-title">
                   {{ $t('campaign.name') }}
                  </span>
                    <b-form-input
                            id="name"
                            :disabled="!canEdit()"
                            v-model="campUpdate.name"
                            type="text"
                            size="mb"
                    />
                </b-form-group>

                <!--Description-->
                <b-form-group
                        class="title"
                        label-for="description">
                  <span class="span-title">
                   {{ $t('campaign.description') }}
                  </span>
                    <b-form-textarea
                            id="description"
                            v-model="campUpdate.description"
                            type="text"
                            size="mb"
                            rows="6"
                    />
                </b-form-group>

                <!--Start date-->
                <b-form-group
                        class="title"
                        label-for="start_date">
                  <span class="span-title">
                   {{ $t('campaign.start_date') }}
                  </span>
                    <b-form-input
                            id="start_date"
                            :disabled="true"
                            v-model="campUpdate.short_start_date"
                            type="date"
                            size="mb"
                    />
                </b-form-group>

                <!--End date-->
                <b-form-group
                        class="title"
                        label-for="end_date">
                  <span class="span-title">
                   {{ $t('campaign.end_date') }}
                  </span>
                    <b-form-input
                            id="endDate"
                            :disabled="!canEdit()"
                            v-model="campUpdate.short_end_date"
                            type="date"
                            size="mb"
                    />
                </b-form-group>

                <!--Organization-->
                <b-form-group
                        class="title"
                        label-for="organization">
                  <span class="span-title">
                   {{ $t('campaign.organization') }}
                  </span>
                    <b-form-input
                            id="organization"
                            v-model="campUpdate.organization.name"
                            type="text"
                            size="mb"
                            :disabled="true"
                    />
                </b-form-group>

                <!--Team select-->
                <b-form-group
                        class="title"
                        label-for="team">
                  <span class="span-title">
                   {{ $t('campaign.team') }}
                  </span>
                    <b-form-select
                            id="team"
                            v-model="campUpdate.team"
                            size="mb"
                            v-on:input="selected"
                            :disabled="teams.length === 0||!canEdit()"
                    >
                        <template slot="first">
                            <option :value="null"
                                    disabled
                            >
                                {{ $t('campaign.select_team') }}
                            </option>
                        </template>
                            <option
                                    v-for="t in teams"
                                    :key="t.id"
                                    :value="t"
                            >
                                {{ t.name }}
                            </option>

                    </b-form-select>
                </b-form-group>

                <!--User select-->
                <b-form-group
                        class="title"
                        label-for="member">
                  <span class="span-title">
                   {{ $t('campaign.user') }}
                  </span>
                    <b-form-select
                            id="member"
                            v-model="campUpdate.user"
                            size="mb"
                            :disabled="users.length === 0 || !canEdit()"
                    >
                        <template slot="first">
                            <option :value="null"
                                    disabled
                            >
                                {{ $t('campaign.select_user') }}
                            </option>
                        </template>
                            <option
                                    v-for="c in users"
                                    :key="c.id"
                                    :value="c"
                            >
                                {{ c.first_name }} {{ c.last_name }}
                            </option>

                    </b-form-select>
                </b-form-group>


                <!--Created by-->
                <b-form-group
                        class="title"
                        label-for="createdBy">
                  <span class="span-title">
                   {{ $t('campaign.created_by') }}
                  </span>
                    <b-form-input
                            id="createdBy"
                            v-model="campUpdate.created_by.email"
                            type="text"
                            size="mb"
                            :disabled="true"
                    />
                </b-form-group>

                <!--Photo-->
                <fair-image-picker
                        :label="$t('campaign.image')"
                        v-model="photo"
                />

                <div class="col-sm-12 no-gutters button-container pb-3 pt-2">
                    <b-button
                            v-if="isEditing() && this.campaign.active"
                            style="background: red"
                            class="fair-button"
                            variant="danger"
                            :disabled="loading"
                            @click.stop="deactivateConfirmation"
                    >
                          <span>
                              {{ $t('common.close') }}
                          </span>
                    </b-button>

                    <b-button
                            class="fair-button"
                            variant="danger"
                            :disabled="loading"
                            @click.stop="$emit('close')"
                    >
                          <span>
                              {{ $t('common.cancel') }}
                          </span>
                    </b-button>

                    <b-button
                            v-if="canEdit() || photo || isDescriptionChanged()"
                            class="fair-button"
                            variant="success"
                            :disabled="loading"
                            @click.stop="submitCampaign"
                    >
                          <span>
                              {{ $t('common.save') }}
                          </span>
                    </b-button>
                </div>
            </div>
        </b-form>

        <b-card v-if="deactivating">
            <b-card-body>
                <div>
                    <span>{{ $t("campaign.deactivating")}}</span>
                </div>
            </b-card-body>
        </b-card>

        <b-modal
                v-if="isEditing() && this.campaign.active"
                v-model="showModal"
                :title="campaign.name"
                @ok="deactivateCampaign">
            {{ $t('campaign.close_dialog')}}
        </b-modal>

        <div
            v-if="loading||deactivating"
            id="loader"
            class="spinner"
        />

    </div>
</template>

<script>
    import FairApi from '../../modules/api'
    import {timeMixin} from "../../mixins/TimeMixin"
    import FairImagePicker from "../FairImagePicker";

    export default {
        name: 'campaign-editor',
        components: {FairImagePicker},
        mixins: [timeMixin],
        props: {
            campaign: {
                type: Object,
                default: null
            },
            photoUrl: {
                type: String,
                default: null
            }
        },

        created() {
            this.campUpdate = this.newCampaign(this.campaign)
            this.fetchTeams()
        },

        data: function () {
            return {
                loading: false,
                campUpdate: null,
                users: [],
                teams: [],
                photo: null,
                showModal: false,
                deactivating: false,
                campaignBackground: null
            }
        },

        mounted() {
            this.fetchBackgroundImage()
        },

        methods: {
            getBackground: function () {
                if (!this.photo) {
                    return this.campaignBackground
                } else {
                    return this.getUrl(this.photo)
                }
            },

            getUrl: function (image) {
                if (image) {
                    URL.revokeObjectURL(image)
                    return URL.createObjectURL(image)
                } else {
                    return ""
                }
            },

            isDescriptionChanged: function() {
              return this.campaign.description !== this.campUpdate.description
            },

            selected: function () {
                this.users = this.campUpdate.team.members
            },

            newCampaign: function (campaign) {
                return {
                    id: null,
                    name: '',
                    description: null,
                    organization: this.$store.state.user.organization,
                    user: null,
                    team: null,
                    start_date: this.getToday(),
                    short_start_date: campaign && campaign.startDate ? this.toShortDateStr(campaign.startDate) : this.getToday(),
                    end_date: campaign && campaign.endDate ? campaign.endDate : this.getNextMonth(),
                    short_end_date: campaign && campaign.endDate ? this.toShortDateStr(campaign.endDate) : this.getNextMonth(),
                    created: new Date().toISOString(),
                    created_by: this.$store.state.user,
                    ...campaign
                }
            },

            fetchTeams: function () {
                FairApi.get(FairApi.team(), this.successTeams, this.fail)
            },

            submitCampaign: function () {
                let json = this.setDefaultValues(this.campUpdate)
                if (json !== undefined) {
                    this.loading = true
                    let formData = new FormData()
                    if (this.campUpdate.photo != null && this.photo == null) {
                        // Editing campaign without changing the picture
                    } else if (this.photo != null) {
                        formData.append('photo', this.photo)
                    }
                    else {
                        this.$emit('alert', this.$t('common.no_picture'))
                        this.loading = false;
                        return;
                    }
                    if (this.isEditing()) {
                        FairApi.postWithFile(FairApi.campaignUpdate(), json, formData, this.success, this.fail)
                    } else {
                        FairApi.postWithFile(FairApi.campaign(), json, formData, this.success, this.fail)
                    }
                }
            },

            setDefaultValues: function (campUpdate) {
                let campaign = JSON.parse(JSON.stringify(campUpdate))
                if (!campaign.name) {
                    this.$emit('alert', this.$t('campaign.invalid_name'))
                    return undefined
                }
                //Filter unnecessary parameters
                campaign.endDate = this.addEndOfDay(campUpdate.short_end_date);
                campaign.startDate = campUpdate.short_start_date
                campaign.organization = undefined
                campaign.created_by = undefined
                campaign.short_start_date=undefined
                campaign.short_end_date=undefined
                if (campaign.team) {
                    campaign.team = {
                        id: campaign.team.id
                    }
                }
                if (campaign.user) {
                    campaign.user = {
                        id: campaign.user.id
                    }
                }
                return campaign
            },

            success: function () {
                this.closeAndUpdate()
            },

            closeAndUpdate: function () {
                this.loading = false
                this.$emit('closeAndUpdate')
            },

            fail: function (response) {
                this.loading = false
                if (response.status === 403) {
                    this.$emit('alert', this.$t('campaign.unauthorized'))
                } else {
                    this.$emit('alert', this.$t('common.alert_update_failed'))
                }
            },

            successTeams: function (response) {
                this.teams = response
                if (this.campUpdate.team !== null) {
                    this.users = this.campUpdate.team.members
                }
            },

            isEditing: function () {
                return this.campaign && this.campaign.id
            },

            canEdit: function () {
                if (this.isEditing()) {
                    const campaignIsExpired = this.campaign.endDate && this.campaign.endDate.length &&
                    new Date().getTime() < new Date(this.campaign.endDate).getTime();
                    return campaignIsExpired
                }
                return true
            },

            deactivateConfirmation: function () {
                this.showModal = true
            },

            deactivateCampaign: function () {
                this.deactivating = true
                FairApi.delete(FairApi.campaign(this.campaign.id), this.successDeactivate, this.failDeactivate)
            },

            successDeactivate: function () {
                this.deactivating = false
                this.closeAndUpdate()
            },

            failDeactivate: function (response) {
                this.deactivating = false
                if (response.status === 403) {
                    this.$emit('alert', this.$t('campaign.unauthorized'))
                } else {
                    this.$emit('alert', this.$t('common.alert_update_failed'))
                }
            },
            fetchBackgroundImage() {
                if (this.campaign && this.campaign.photo) {
                    FairApi.get(FairApi.photo(this.campaign.photo.id), this.successPhoto, this.failPhoto)
                } else {
                    this.loading = false
                }
            },

            successPhoto(response) {
                this.campaignBackground = response
                this.loading = false
            },

            failPhoto() {
                this.loading  = false
            },


        }
    }
</script>